import { E as EmblaCarousel } from './embla-carousel.esm-DpJzJcqm.js';
import { W as WheelGesturesPlugin } from './embla-carousel-wheel-gestures.esm-BxgUSOtT.js';
import { a as addPrevNextButtonClickHandlers } from './arrow-buttons-CGj8dylI.js';
import { t as toggleBooleanAttribute } from './toggleBooleanAttribute-Cp5m6OeZ.js';

class CardSlider extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;
  /** @type {import('embla-carousel').EmblaCarouselOptions} */
  #options = {
    align: 'start',
    dragFree: true,
    slidesToScroll: 'auto',
  };

  connectedCallback() {
    const viewport = this.querySelector('.embla__viewport');
    if (!viewport) return;

    this.#embla = this.#initEmbla(viewport);
    this.#initNavigation();
  }

  disconnectedCallback() {
    this.#embla?.destroy();
    this.#embla = undefined;
  }

  /**
   * Re-initializes Embla after slides are replaced in the DOM.
   * @returns {void}
   */
  reInit() {
    this.#embla?.reInit();
  }

  /**
   * Initializes the Embla carousel
   * @param {HTMLElement} viewport
   * @returns {import('embla-carousel').EmblaCarouselType}
   */
  #initEmbla(viewport) {
    return EmblaCarousel(viewport, this.#options, [WheelGesturesPlugin()]);
  }

  /**
   * Whether the carousel has overflow content to scroll
   * @returns {boolean}
   */
  #canScroll() {
    if (!this.#embla) return false;
    if (this.#embla.canGoToPrev() || this.#embla.canGoToNext()) return true;

    const viewport = this.#embla.rootNode();
    const container = this.#embla.containerNode();
    return container.scrollWidth > viewport.clientWidth + 1;
  }

  /**
   * Initializes the navigation buttons
   * @returns {void}
   */
  #initNavigation() {
    const nav =
      this.querySelector('[data-card-slider-nav]') ??
      this.closest('section')?.querySelector('[data-card-slider-nav]');
    const prevBtn = nav?.querySelector('[data-embla-button="prev"]');
    const nextBtn = nav?.querySelector('[data-embla-button="next"]');

    if (prevBtn && nextBtn) addPrevNextButtonClickHandlers(this.#embla, prevBtn, nextBtn);

    if (!nav) return;

    const toggleNavVisibility = () => {
      toggleBooleanAttribute(nav, 'aria-hidden', this.#canScroll() ? 'false' : 'true');
    };

    toggleNavVisibility();
    this.#embla.on('reinit', toggleNavVisibility).on('select', toggleNavVisibility);
  }
}

if (!customElements.get('card-slider')) {
  customElements.define('card-slider', CardSlider);
}
